import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { bloodOrSkinDisease } from './bloodOrSkinDisease';
import { otherPhysicalMentalHealth } from './otherPhysicalMentalHealth';

export const general: AnswerPathTreeNode = {
  path: 'general',
  children: [otherPhysicalMentalHealth, bloodOrSkinDisease],
};
